import React from 'react'
import { Field } from 'formik'
import { Form } from '_zari/core'

const IndicadorVentaFormGroup = ({ iEnabled, iValue, fIsSubmitting }) => {
  return (
    <Field name='flagVenta'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          disabled={!iEnabled || fIsSubmitting}
          checked={iValue}
          id='checkbox-flagVenta'
          label='VENTAS'
        />
      )}
    </Field>
  )
}

export default React.memo(IndicadorVentaFormGroup)
